import { render, staticRenderFns } from "./OrganizationSubmenu.vue?vue&type=template&id=11a8bded"
import script from "./OrganizationSubmenu.vue?vue&type=script&lang=js"
export * from "./OrganizationSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports